export { default } from './StravaMentionsInput';
